import { getUID } from 'echarts/lib/util/component'
import apiDefaultConfig from './coreApiDefaultConfig'
import { getCurrentAccountData, getCurrentProjectData } from '@/auth/utils'
import { runCoreApiGetRequest, updateCoreApiDataOnProgress, updateCoreApiData } from '@/coreApi/coreApi'
import coreApiDataIndex from '@/coreApi/coreApiDataIndex'
import { getCoreApiByObjectId } from '@/coreApi/coreApiHelper'

const queryInterval = []
const queryProcessActive = {}
const queryLock = {}

function processRunCoreApiGetRequest(dataIndex, url) {
    const processKey = getUID()
    queryProcessActive[dataIndex] = processKey
    queryLock[url] = true
    try {
        runCoreApiGetRequest(url).then(response => {
            queryLock[url] = false
            if (typeof queryProcessActive[dataIndex] !== 'undefined' && queryProcessActive[dataIndex] === processKey) {
                updateCoreApiData(dataIndex, response.data)
                queryProcessActive[dataIndex] = null
            }
        }).catch(error => {
            queryLock[url] = false
            console.log('processRunCoreApiGetRequest error', error.response)
        })
    } catch (error) {
        queryLock[url] = false
        console.log('processRunCoreApiGetRequest error', error) // <=== Error will be catch here!
    }
}

export function executeQuery(dataIndex, query, timerMS) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.coreRequest
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{data-index}', dataIndex)
        .replace('{query}', Buffer.from(JSON.stringify(query)).toString('base64'))}`

    queryLock[url] = false
    if (timerMS) {
        // eslint-disable-next-line no-unused-expressions
        queryInterval[dataIndex] && clearInterval(queryInterval[dataIndex])

        processRunCoreApiGetRequest(dataIndex, url)
        updateCoreApiDataOnProgress(dataIndex, true)
        // eslint-disable-next-line no-shadow
        queryInterval[dataIndex] = setInterval((dataIndex, url) => {
            if (!queryLock[url]) {
                processRunCoreApiGetRequest(dataIndex, url)
            }
        }, timerMS, dataIndex, url)
    } else {
        updateCoreApiDataOnProgress(dataIndex, true)
        processRunCoreApiGetRequest(dataIndex, url)
    }
}

// eslint-disable-next-line consistent-return
export function recursivelyExecuteQuery(query, execute, maxLimit = 100000, limit = 5000, offset = 0, data = [], count = 0) {
    if ((offset + limit) > maxLimit) {
        // console.log('burada')
        execute(data)
        return 0
    }

    if (query.request_nodes.length !== 1) {
        execute([])
        return 0
    }

    if (count > 25) {
        execute([])
        return 0
    }

    // eslint-disable-next-line no-param-reassign
    count += 1

    // eslint-disable-next-line no-restricted-syntax
    for (const [index, option] of Object.values(query.request_nodes[0].options).entries()) {
        if (option.alias === query.request_nodes[0].alias) {
            // eslint-disable-next-line no-param-reassign
            query.request_nodes[0].options[index].return_id = 'data'
            // eslint-disable-next-line no-param-reassign
            query.request_nodes[0].options[index].limit = limit
            // eslint-disable-next-line no-param-reassign
            query.request_nodes[0].options[index].offset = offset
            break
        }
    }

    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.coreRequest
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{data-index}', 21)
        .replace('{query}', Buffer.from(JSON.stringify(query)).toString('base64'))}`

    runCoreApiGetRequest(url).then(response => {
        const object = getCoreApiByObjectId(response.data, 'data')
        if (object
          && 'data' in object
          && object.data.length
        ) {
            // eslint-disable-next-line no-param-reassign
            data = [...data, ...object.data]
            recursivelyExecuteQuery(query, execute, maxLimit, limit, offset + limit, data, count)
        } else {
            execute(data)
        }
    }).catch(error => {
        console.log('processRunCoreApiGetRequest error', error.response)
        execute([])
    })
}

export function resetQueries() {
    // eslint-disable-next-line no-restricted-syntax
    for (const [, queryIntervalElement] of Object.entries(queryInterval)) {
        if (queryIntervalElement) {
            clearInterval(queryIntervalElement)
        }
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const [dataIndex] of Object.entries(coreApiDataIndex)) {
        updateCoreApiData(dataIndex, {})
        delete queryProcessActive[dataIndex]
    }
}

export function resetQuery(dataIndex) {
    // eslint-disable-next-line no-restricted-syntax
    for (const [currentDataIndex, queryIntervalElement] of Object.entries(queryInterval)) {
        if (dataIndex === currentDataIndex && queryIntervalElement) {
            clearInterval(queryIntervalElement)
        }
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const [currentDataIndex] of Object.entries(coreApiDataIndex)) {
        if (dataIndex === currentDataIndex) {
            updateCoreApiData(currentDataIndex, {})
        }
    }
    delete queryProcessActive[dataIndex]
}
